import SplashPage from '@scoir/splash-page'

import artwork from './handraisersSplash.png'

const HandraisersSplash = () => {
  return (
    <SplashPage
      title="Reach Interested Students"
      titleColor="secondaryToBlue"
      subtitle="Unlock direct access to your future applicants."
      body={`Upgrade your plan to see students who have opted in to connect with your institution. Automatically sync student data directly to your CRM via SFTP to ensure you can begin personal outreach the moment interest is shared.`}
      artwork={artwork}
      artworkProps={{ alt: 'Handraisers Illustration' }}
      buttonText="Learn More"
      buttonHref={'https://www.scoir.com/colleges/feature-handraisers'}
      showLearnMoreLink={false}
      newTab
    />
  )
}

export default HandraisersSplash
